import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import dateFormat from 'dateformat';

import MyAppBar from '../../components/MyAppBar';
import { Container, Paper } from '@mui/material';

const styles = {
  container: {
    padding: 1,
  },
  paper: {
    margin: 2,
    padding: 4,
  },
  indent: {
    paddingLeft: 5,
  },
};

function getAmPm(time) {
  if (time >= 12) {
    return 'AM';
  } else {
    return 'PM';
  }
}

function getHearingTime(hearing) {
  console.log('hearing:');
  console.log(hearing);
  if (hearing && hearing.HEARING_TIME) {
    const time = hearing.HEARING_TIME.toString();
    if (time.length <= 3) {
      return `${time.substr(0, 1)}:${time.substr(1, 2)} ${getAmPm(
        hearing.HEARING_TIME
      )}`;
    } else {
      return `${time.substr(0, 2)}:${time.substr(2, 2)} ${getAmPm(
        hearing.HEARING_TIME
      )}`;
    }
  } else {
    return '';
  }
}

function getHearingDate(hearing) {
  if (hearing && hearing.HEARING_DATE) {
    const date = new Date(hearing.HEARING_DATE);
    console.log('date: ', date);
    return dateFormat(new Date(hearing.HEARING_DATE), 'mm/dd/yyyy', true);
  }
  return '';
}

function get17DaysHearingDate(hearing) {
  if (hearing && hearing.HEARING_DATE) {
    const nextDate = new Date(hearing.HEARING_DATE);
    nextDate.setDate(nextDate.getDate() + 17);
    return dateFormat(nextDate, 'mm/dd/yyyy', true);
  } else {
    return '';
  }
}

function get8DaysHearingDate(hearing) {
  if (hearing && hearing.HEARING_DATE) {
    const nextDate = new Date(hearing.HEARING_DATE);
    nextDate.setDate(nextDate.getDate() + 8);
    return dateFormat(nextDate, 'mm/dd/yyyy', true);
  } else {
    return '';
  }
}

export default function C(props) {
  const { yearmonth } = useParams();
  const [year, month] = yearmonth.split('-');
  const [hearing, setHearing] = useState({});

  useEffect(() => {
    const getHearing = async () => {
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/hearing/${year}/${month}`
      );
      const hearing = await response.json();
      setHearing(hearing);
    };
    getHearing();
  }, [month, year]);

  return (
    <React.Fragment>
      <MyAppBar title='Appendix C - Summary' />
      <Container sx={styles.container}>
        <Paper sx={styles.paper}>
          {window.config.client === 'FT-BEND' ? (
            <>
              <p>
                At approximately {getHearingTime(hearing)} on{' '}
                {getHearingDate(hearing)}, public hearing was convened at the
                office of the Subsidence District at 301 Jackson St. Suite 639,
                Richmond, TX 77469.
              </p>
              <p>
                It was verified that proper notices had been issued in
                accordance with the District's enabling legislation, the Rules
                of the District, and the Open Meetings Act.
              </p>
              <p>
                After opening the hearings and explaining some procedural steps,
                the Hearing Examiner administered the oath to those in the
                audience who expected to testify. It was subsequently verified
                that each person who testified had taken the oath.
              </p>
              <p>
                After hearing testimony and introducing into the record other
                evidence, the Hearing Examiner held the record open until 5:00
                p.m., {get8DaysHearingDate(hearing)}.
              </p>
              <p>
                A list of those applicants heard is shown in the Table of
                Contents of this report.
              </p>
              <p>
                The report deals with each applicant individually. The District
                Plan divides the District into two Regulatory Areas. For ease of
                identification, the Area in which the well(s) is located is
                noted on the first page of the applicant's report.
              </p>
            </>
          ) : (
            <>
              <p>
                At approximately {getHearingTime(hearing)} on{' '}
                {getHearingDate(hearing)}, public hearing was convened at the
                office of the Subsidence District at 1660 West Bay Area Blvd.,
                Friendswood, Harris County, Texas.
              </p>
              <p>
                It was verified that proper notices had been issued in
                accordance with the District's enabling legislation, the Rules
                of the District, and the Open Meetings Act.
              </p>
              <p>
                After opening the hearings and explaining some procedural steps,
                the Hearing Examiner administered the oath to those in the
                audience who expected to testify. It was subsequently verified
                that each person who testified had taken the oath.
              </p>
              <p>
                After hearing testimony and introducing into the record other
                evidence, the Hearing Examiner held the record open until{' '}
                {getHearingTime(hearing)}, {get17DaysHearingDate(hearing)}.
              </p>
              <p>
                A list of those applicants heard is shown in the Table of
                Contents.
              </p>
              <p>
                The report deals with each applicant individually. The District
                Plan divides the District into Three Regulatory Areas. For ease
                of identification, the Area in which the well(s) is located is
                noted on the first page of the applicant's report.
              </p>
            </>
          )}
          {hearing.HEARING_LOCATION && <p>{hearing.HEARING_LOCATION}</p>}
        </Paper>
      </Container>
    </React.Fragment>
  );
}
